export const SET_USER = (state, payload) => {
  state.user = payload
}

export const SET_TOKEN_EXPIRES = (state, payload) => {
  state.expires = payload
}
export const STORE_ACCESS_TOKEN = (state, payload) => {
  state.token = payload
  localStorage.setItem('token', payload)
}

export const SET_PORTAL = (state, payload) => {
  state.portal = payload
}

export const SET_AUTH = (state, { token, user, roles, expires }) => {
  localStorage.setItem('token', token)
  localStorage.setItem('user', user)
  Object.assign(state, {
    token: token,
    user: user,
    roles: roles,
    expires: expires
  })
}

export const LOGOUT_USER = state => {
  state.user = null
  state.token = null
  state.roles = []
  state.expires = null
  localStorage.removeItem('token')
  localStorage.removeItem('user')
}

export const SET_LOGIN_KEY = (state, { key, value }) => {
  state.login[key] = value
}
